import React from "react";
import "../styles/Livrare&Plata.css";

const LivrareSiPlata = () => {
  return (
    <section className="section section-livrare-si-plata">
      <h1 className="heading-secondary heading-delivery-payment">
        Livrarea și plata florilor simplificate: ghidul tău pentru comanda
        florilor online fără de griji.
      </h1>
      <p className="section-description section-description-delivery">
        Bine ați venit într-o lume în care cumpărarea buchetului perfect de
        flori nu este doar posibilă, ci și extrem de simplă și convenabilă.
        Site-ul nostru oferă o selecție largă de buchete care pot deveni o
        expresie a sentimentelor tale, mulțumiri sau felicitări celor dragi.
        Iată un ghid pentru a vă ajuta să navigați cu ușurință în selecția
        noastră, bucurându-vă în același timp de beneficiile cumpărăturilor
        online.
      </p>
      <h2 className="section-subtitle">Selectarea buchetului perfect</h2>
      <p className="section-text">
        Începe prin a selecta buchetul perfect care reflectă cel mai bine
        intențiile tale. Interfața noastră intuitivă oferă asistență la fiecare
        pas - de la utilizarea filtrelor de preț până la navigarea printr-o
        varietate de categorii de flori.
      </p>
      <h2 className="section-subtitle">Procesul de comandă - pas cu pas</h2>
      <p className="section-text">
        După alegerea unui buchet, adăugați-l în coș și treceți la etapa de
        finalizare. Procesul este intuitiv - necesită doar să introduceți
        detaliile de livrare și să alegeți metoda de plată preferată. În cele
        din urmă, veți primi o confirmare a comenzii generată automat pe adresa
        de e-mail, ceea ce este o garanție că totul a mers bine.
      </p>
      <h2 className="section-subtitle">Modalități de Plată</h2>
      <p className="section-text">
        Oferim o varietate citeva metode de plată pentru a vă facilita
        achizițiile:
        <p>
          • Plata online cu card bancar: Puteți efectua plata în siguranță
          utilizând carduri Visa, MasterCard, Paynet. După ce ați selectat
          produsele dorite și ați completat formularul de comandă, veți fi
          redirecționat către pagina securizată a partenerului nostru de plăți,
          unde veți introduce detaliile cardului.
        </p>
        <p>
          • Plata în numerar, la oficiu sau la livrare: În anumite zone, oferim
          posibilitatea de a plăti în numerar la momentul livrării. Vă rugăm să
          verificați disponibilitatea acestei opțiuni în zona dumneavoastră și
          să aveți suma exactă pregătită pentru a facilita tranzacția.
        </p>
      </p>
      <h2 className="section-subtitle">Condiții de livrare</h2>
      <p className="section-text">
        Ne angajăm să livrăm produsele noastre în cele mai bune condiții și la
        momentul potrivit pentru dumneavoastră:
        <p>
          • Program de Livrare: Efectuăm livrări zilnic, inclusiv în weekenduri.
          În funcție de locație, intervalele orare pot varia. Vă rugăm să
          specificați data și ora preferată pentru livrare în momentul plasării
          comenzii, iar noi vom face tot posibilul să respectăm aceste
          preferințe.
        </p>
        <p>
          • Zone de Livrare și Costuri: Oferim livrări în Chișinău și pe
          teritoriul întregii republici. Costul exact al livrării va fi calculat
          și afișat în timpul procesului de comandă, înainte de finalizarea
          acesteia.
        </p>
        <p>
          • Livrare Anonimă: Înțelegem că, uneori, doriți să surprindeți pe
          cineva în mod anonim. Asigurăm confidențialitatea completă pentru
          astfel de livrări. Vă rugăm să menționați această preferință în timpul
          plasării comenzii.
        </p>
        <p>
          • Condiții Speciale: Pentru ocazii speciale sau cerințe specifice, cum
          ar fi livrări la ore exacte sau în locații mai puțin accesibile, vă
          rugăm să ne contactați în prealabil pentru a discuta detaliile și a
          confirma posibilitatea și eventualele costuri suplimentare.
        </p>
      </p>
      <h2 className="section-subtitle">Informații Suplimentare</h2>
      <p className="section-text">
        • Modificări și Anulări: Dacă doriți să modificați sau să anulați o
        comandă, vă rugăm să ne informați cât mai curând posibil. Vom face tot
        posibilul să acomodăm solicitarea, însă vă rugăm să rețineți că, odată
        ce comanda a fost procesată sau expediată, modificările pot să nu mai
        fie posibile.
        <p>
          • Politica de Returnare: Datorită naturii perisabile a produselor
          noastre, returnările nu sunt acceptate. Cu toate acestea, dacă există
          vreo problemă cu comanda dumneavoastră, vă rugăm să ne contactați
          imediat, iar noi vom lucra pentru a găsi o soluție satisfăcătoare.
        </p>
      </p>
      <p className="section-text">
        Pentru orice întrebări sau clarificări suplimentare referitoare la
        condițiile de plată și livrare, nu ezitați să ne contactați. Suntem aici
        pentru a vă asigura o experiență cât mai plăcută și fără griji.
      </p>
    </section>
  );
};

export default LivrareSiPlata;
